// extracted by mini-css-extract-plugin
export default {"routineblock":"PP","container":"QP","carousel":"RP","routine":"SP","heading":"TP","routinelist":"UP","routineitem":"VP","routineimg":"WP","routinedesc":"XP","routinename":"YP","routinetext":"ZP","carouselwrap":"aQ"};
    if(module.hot) {
      // 1715188238007
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  